type BinaryAsset = {
  blob: Blob;
  owners: Set<string>;
};

/** Keeps binary data outside the serializable document and its history snapshots. */
export class BinaryAssetRegistry {
  private readonly assets = new Map<string, BinaryAsset>();

  register(id: string, blob: Blob): void {
    this.assets.set(id, { blob, owners: new Set() });
  }

  get(id: string): Blob | undefined {
    return this.assets.get(id)?.blob;
  }

  retain(id: string, owner: string): void {
    this.assets.get(id)?.owners.add(owner);
  }

  release(id: string, owner: string): void {
    const asset = this.assets.get(id);
    if (!asset) return;
    asset.owners.delete(owner);
    if (asset.owners.size === 0) this.assets.delete(id);
  }

  clear(): void {
    this.assets.clear();
  }
}

export const binaryAssetRegistry = new BinaryAssetRegistry();
